export const experienceTimelineItems = [
  {
    id: 'emr-team-lead',
    title: 'Development Team Lead',
    subtitle: 'EMR Group',
    dateRange: 'October 2022 - Present',
    startDate: '2022-10-01',
    endDate: null,
    type: 'work',
    iconLabel: 'TL',
    content: [
      'Leading a team of software developers to deliver high-quality solutions, streamline processes, and uphold engineering best practices.'
    ]
  },
  {
    id: 'centric-consulting',
    title: 'Consultant',
    subtitle: 'Centric Consulting',
    dateRange: 'May 2022 - October 2022',
    startDate: '2022-05-01',
    endDate: '2022-10-01',
    type: 'work',
    iconLabel: 'CT',
    content: [
      'Partnered with cross-functional teams as a full stack developer, aligning React.js front ends with robust C# services.'
    ]
  },
  {
    id: 'sixleaf-senior-dev',
    title: 'Senior Software Developer',
    subtitle: 'SixLeaf',
    dateRange: 'September 2021 - May 2022',
    startDate: '2021-09-01',
    endDate: '2022-05-01',
    type: 'work',
    iconLabel: 'SD',
    content: [
      'Optimized APIs, streamlined data retrieval, and enhanced e-commerce tooling to elevate performance and user experience.'
    ]
  },
  {
    id: 'izenda-software-dev',
    title: 'Software Developer',
    subtitle: 'Izenda',
    dateRange: 'June 2020 - September 2021',
    startDate: '2020-06-01',
    endDate: '2021-09-01',
    type: 'work',
    iconLabel: 'SD',
    content: [
      'Collaborated across development, QA, and DevOps to ship features end-to-end, supporting a rapid release cadence.'
    ]
  },
  {
    id: 'daffodil-software-dev',
    title: 'Software Developer',
    subtitle: 'Daffodil Software',
    dateRange: 'March 2018 - June 2020',
    startDate: '2018-03-01',
    endDate: '2020-06-01',
    type: 'work',
    iconLabel: 'SD',
    content: [
      'Enhanced Apprende, a healthcare-focused CMS, by expanding functionality and improving system performance.'
    ]
  },
  {
    id: 'freelance',
    title: 'Freelancer',
    subtitle: 'Self-Employed',
    dateRange: 'January 2017 - February 2018',
    startDate: '2017-01-01',
    endDate: '2018-02-01',
    type: 'work',
    iconLabel: 'FR',
    content: [
      'Delivered bespoke web applications for clients, managing projects from planning through deployment.'
    ]
  },
  {
    id: 'iiit-allahabad',
    title: 'B.Tech in Information Technology',
    subtitle: 'Indian Institute of Information Technology, Allahabad',
    dateRange: 'July 2012 - June 2016',
    startDate: '2012-07-01',
    endDate: '2016-06-01',
    type: 'education',
    iconLabel: 'ED',
    content: [
      'Coursework spanned data structures, algorithms, software engineering, and database systems, supported by collaborative projects.'
    ]
  }
];
